import AddNoteHtml                   from '../core/templates/note.add.html';
import AddNotesCell                  from '../../app-lite/grids/templates/cell.add-notes.html';
import AutoCreateOrderHtml           from './templates/purchase-order.auto-create.html';
import DatePickerCellHtml            from '../../app-lite/grids/templates/cell.date-picker.html';
import DynamicColorSelectableRowHtml from '../../app-lite/grids/templates/row.dynamic-color.selectable.html';
import EditableCellHtml              from '../../app-lite/grids/templates/cell.editable.html';
import EditableCurrencyCellHtml      from '../../app-lite/grids/templates/cell.currency.editable.html';
import EditableNumberCellHtml        from '../../app-lite/grids/templates/cell.number.editable.html';
import OrderActionCellHtml           from './templates/order.action.cell.html';
import ProductSearchCellHtml         from '../../app-lite/products/templates/product-search.cell.html';
import UnsortableHeaderCellHtml      from '../../app-lite/grids/templates/cell.unsortable-header.html';

export function PurchaseOrderCtrl (
    $q,
    $scope,
    $state,
    $stateParams,
    $translate,
    $uibModal,
    $window,
    API,
    AshdownOrders,
    blockUI,
    bursonApi,
    company,
    confirm,
    dateParsing,
    dealership,
    gridAPI,
    gsfApi,
    HsyOrder,
    messages,
    messengerApi,
    Order,
    PartsAuthorityOrder,
    partstechApi,
    partstech_orders,
    productApi,
    productSearchApi,
    PROLinkOrders,
    purchase_order,
    reorderGrid,
    sessionObjAPI,
    Vendor,
    vendor,
    workshopAPI
) {
  $scope.block            = blockUI.instances.get('orderBlock');
  $scope.company          = company;
  $scope.currency         = sessionObjAPI.currency();
  $scope.editMode         = false;
  $scope.selectMode       = false;
  $scope.loaded           = true;
  $scope.vendor           = vendor           || {};
  $scope.partstech_orders = partstech_orders || [];
  $scope.dealership       = dealership       || {};

  $scope.showPartstechOrders = !!$scope.partstech_orders.length;

  $scope.purchase_order = purchase_order || {
    id                             : '',
    vendor_id                      : vendor ? vendor.id : '',
    order_date                     : dateParsing.today(),
    order_number                   : '',
    total                          : 0.00,
    status                         : 'S',
    note                           : '',
    due_date                       : dateParsing.today(),
    gsf_order_number               : '',
    purchase_order_items_attributes: [{
      cost_including_tax: 0.00,
      description       : '',
      gst_free          : false,
      id                : '',
      item_code         : '',
      item_due_date     : '',
      note              : '',
      product_id        : '',
      purchase_order_id : '',
      quantity_ordered  : 0,
      total             : 0.00,
      unit_cost         : 0.00,
      untouched         : true,
      getTotal () {
        var unit_cost = new BigDecimal( this.unit_cost ? this.unit_cost.toString(): '0' ).setScale(4, BigDecimal.ROUND_HALF_UP);
        var quantity_ordered = new BigDecimal( this.quantity_ordered ? this.quantity_ordered.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

        if (!$scope.editable) {
          return this.total;
        }

        return unit_cost
          .multiply(quantity_ordered)
          .setScale(4, BigDecimal.prototype.ROUND_HALF_UP)
          .toString();
      },
      getTotalIncludingTax () {
        var costIncludingTax = new BigDecimal( this.cost_including_tax ? this.cost_including_tax.toString(): '0' ).setScale(4, BigDecimal.ROUND_HALF_UP);
        var quantityOrdered = new BigDecimal( this.quantity_ordered ? this.quantity_ordered.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

        return costIncludingTax
          .multiply(quantityOrdered)
          .setScale(4, BigDecimal.prototype.ROUND_HALF_UP)
          .toString();
      }
    }],
    itemsToDelete: []
  };

  $scope.Order  = new Order($scope.purchase_order);
  $scope.Vendor = new Vendor($scope.vendor);

  $scope.Ashdown             = new AshdownOrders();
  $scope.HsyOrder            = new HsyOrder($scope.vendor, 'order');
  $scope.PartsAuthorityOrder = new PartsAuthorityOrder($scope.company, $scope.Order.order);
  $scope.PROLink             = new PROLinkOrders();

  $scope.prolink = {
    vendor: $scope.Order.prolink(),
    active: sessionObjAPI.company().has_prolink
  };

  $scope.repco = {
    vendor: $scope.Order.repco(),
    active: sessionObjAPI.company().has_repco
  };

  $scope.ashdown = {
    vendor: $scope.Order.ashdown(),
    active: sessionObjAPI.company().has_ashdown_ingram
  };

  $scope.editable = !$scope.Order.closed();

  $scope.vendorSelected = function (vendor) {
    $state.go('app.purchase-order', {
      vendor_id: vendor.id
    });
  };

  $scope.grid = {
    beforeSelectionChange (item) {
      // If item is an array, cancel was pressed. Return true to unselect all selected items.
      if (angular.isArray(item)) {
        return true;
      }

      return $scope.selectMode && item.entity && !item.entity.job_card_number;
    },
    cellEditableCondition  : 'editable && !editMode && !selectMode',
    data                   : 'purchase_order.purchase_order_items_attributes',
    enableCellEditOnFocus  : true,
    enableCellSelection    : true,
    enableRowSelection     : true,
    enableSorting          : false,
    multiSelect            : true,
    rowHeight              : 43,
    rowTemplate            : DynamicColorSelectableRowHtml,
    selectedItems          : [],
    virtualizationThreshold: 9999,
    columnDefs             : [
      {
        cellTemplate      : OrderActionCellHtml,
        displayName       : '',
        enableCellEdit    : false,
        headerCellTemplate: UnsortableHeaderCellHtml,
        width             : '43px'
      },
      {
        cellClass            : 'Uppercase',
        cellEditableCondition: 'editable && !editMode && !selectMode',
        displayName          : $translate.instant('PRODUCT_SPACE.PRODUCT'),
        editableCellTemplate : ProductSearchCellHtml,
        field                : 'item_code',
        headerCellTemplate   : UnsortableHeaderCellHtml,
        width                : '175px'
      },
      {
        cellClass            : 'Capitalize',
        cellEditableCondition: 'editable && row.entity.product_id',
        displayName          : $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION'),
        editableCellTemplate : EditableCellHtml,
        field                : 'description',
        headerCellTemplate   : UnsortableHeaderCellHtml
      },
      {
        cellTemplate  : AddNotesCell,
        enableCellEdit: false,
        width         : '43px'
      },
      {
        cellClass         : 'align-right ReadOnly',
        displayName       : $translate.instant('INVOICE_SPACE.JOB_CARD_NUMBER'),
        enableCellEdit    : false,
        field             : 'job_card_number',
        headerCellTemplate: UnsortableHeaderCellHtml,
        width             : '120px'
      },
      {
        /**
         * ng-grid takes their expressions as strings and inserts them manually into the DOM.
         * Since this is a custom template, use a function to check its editability.
         */
        cellEditableCondition: (row) => $scope.editable && row.entity.item_code,
        cellFilter           : 'date',
        cellTemplate         : DatePickerCellHtml,
        displayName          : $translate.instant('PURCHASE_ORDER_SPACE.DUE_DATE'),
        enableCellEdit       : false,
        field                : 'item_due_date',
        headerCellTemplate   : UnsortableHeaderCellHtml
      },
      {
        cellClass            : 'align-right gridCurrency',
        cellEditableCondition: 'editable && row.entity.product_id && !editMode && !selectMode',
        cellFilter           : 'globalCurrency:4',
        displayName          : $translate.instant('JS_SPACE.COLUMNS.UNIT_COST'),
        editableCellTemplate : EditableCurrencyCellHtml,
        field                : 'unit_cost',
        headerCellTemplate   : UnsortableHeaderCellHtml,
        min                  : -99999,
        round                : 4,
        onChange             (row) {
          $scope.updateCostIncludingTax(row.entity);
        }
      },
      {
        cellClass            : 'align-right',
        cellEditableCondition: 'editable && row.entity.product_id && !editMode && !selectMode',
        cellFilter           : 'globalCurrency:4',
        displayName          : $translate.instant('PRODUCT_SPACE.COST_WITH_TAX'),
        editableCellTemplate : EditableCurrencyCellHtml,
        field                : 'cost_including_tax',
        headerCellTemplate   : UnsortableHeaderCellHtml,
        min                  : -99999,
        round                : 4,
        width                : '120px',
        onChange             (row) {
          $scope.updateCost(row.entity);
        }
      },
      {
        cellClass            : 'align-right',
        cellEditableCondition: 'canEditQuantity(row.entity)',
        cellFilter           : 'number',
        displayName          : $translate.instant('PRODUCT_SPACE.QTY'),
        editableCellTemplate : EditableNumberCellHtml,
        field                : 'quantity_ordered',
        headerCellTemplate   : UnsortableHeaderCellHtml,
        width                : '61px'
      },
      {
        cellClass         : 'align-right ReadOnly',
        cellFilter        : 'globalCurrency',
        displayName       : $translate.instant('INVOICE_SPACE.LINE_TOTAL'),
        enableCellEdit    : false,
        field             : 'getTotal()',
        headerCellTemplate: UnsortableHeaderCellHtml,
        width             : '101px'
      },
      {
        cellClass         : 'align-right ReadOnly',
        cellFilter        : 'globalCurrency',
        displayName       : $translate.instant('PRODUCT_SPACE.TOTAL_WITH_TAX'),
        enableCellEdit    : false,
        field             : 'getTotalIncludingTax()',
        headerCellTemplate: UnsortableHeaderCellHtml,
        width             : '120px'
      }
    ]
  };

  // determine if an order line item's quantity
  // can be updated or not.
  $scope.canEditQuantity = function (entity) {
    if ($scope.editable && entity.product_id && !$scope.editMode && !$scope.selectMode && entity.item_code !== 'ACQUISITION') {
      return true;
    }

    return false;
  };

  // Save the purchase order first in order to get
  // the purchase_order_id id and acquisition item id.
  // Then refresh page with item id.
  $scope.prepAcquisition = function (index) {
    $scope.Order.save()
    .then(order => {
      $scope.purchase_order = order;
      $scope.setFlagsAndFunctions();

      $state.go('app.purchase-order', {
        vendor_id           : $scope.purchase_order.vendor_id,
        id                  : $scope.purchase_order.id,
        acquisition_order_id: $scope.purchase_order.purchase_order_items_attributes[index].id
      });
    })
    .catch(error => {
      messages.error(error);

      $scope.reload();
    });
  };

  $scope.acquisitionCredit = function (index) {
    $scope.Order.launchAcquisitionCreditModal()
      .then(function (data) {
        angular.extend($scope.purchase_order.purchase_order_items_attributes[index], data);
        $scope.purchase_order.purchase_order_items_attributes[index].display_cost = data.unit_cost;
      }, function (error) {
        messages.error(error);
      });
  };

  $scope.launchAcquisition = function () {
    var acquisitionIndex = -1;

    // Find the invoice line item's index for the
    // acquisition we are currently working with.
    for (var i=0; i<$scope.purchase_order.purchase_order_items_attributes.length; i++) {
      acquisitionIndex = $scope.purchase_order.purchase_order_items_attributes[i].id === $stateParams.acquisition_order_id ?
        i: acquisitionIndex;
    }

    $scope.Order.launchAcquisitionModal()
    .then(acquisitions => {
      var params = {
        vehicles: []
      };

      // Build params for acquisitions call.
      angular.forEach(acquisitions, acquisition => {
        acquisition.unit.acquisition_order_id      = $scope.purchase_order.id;
        acquisition.unit.acquisition_order_item_id = $scope.purchase_order.purchase_order_items_attributes[acquisitionIndex].id;
        acquisition.unit.acquisition_order_status  = $scope.purchase_order.status;

        params.vehicles.push(acquisition.unit);
      });

      // Set quantity and price for the invoice line item.
      $scope.purchase_order.purchase_order_items_attributes[acquisitionIndex].description        = acquisitions[0].unit.find_description;
      $scope.purchase_order.purchase_order_items_attributes[acquisitionIndex].gst_free           = acquisitions[0].unit.gst_free;
      $scope.purchase_order.purchase_order_items_attributes[acquisitionIndex].quantity_ordered   = acquisitions.length;
      $scope.purchase_order.purchase_order_items_attributes[acquisitionIndex].unit_cost          =
        BigDecimal.ZERO.add(new BigDecimal(acquisitions[0].unit.value_of_acquisition.toString() || '0')).toString();
      $scope.purchase_order.purchase_order_items_attributes[acquisitionIndex].cost_including_tax =
        (acquisitions[0].unit.gst_free) ?  BigDecimal.ZERO.add(new BigDecimal(acquisitions[0].unit.value_of_acquisition.toString() || '0')).toString()
        : BigDecimal.ZERO.add(new BigDecimal(acquisitions[0].unit.value_of_acquisition_including_tax.toString() || '0')).toString();

      return workshopAPI.post('/vehicles/acquisitions', params, 'vehicle_acquisition');
    })
    .then(() => $scope.Order.save())
    .then(() => {
      messages.show(
        $scope.purchase_order.purchase_order_items_attributes[acquisitionIndex].quantity > 1 ? $translate.instant('DEALERSHIP_SPACE.UNITS_ACQUIRED') : $translate.instant('DEALERSHIP_SPACE.UNIT_ACQUIRED'),
      'success');
    })
    .catch(error => {
      acquisitionIndex >= 0 ? $scope.removeItem({
        entity  : $scope.purchase_order.purchase_order_items_attributes[acquisitionIndex],
        rowIndex: acquisitionIndex
      }) : null;

      messages.error(error);

      return $scope.Order.save();
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => $scope.reload());
  };

  $scope.updateCostIncludingTax = function (item) {
    item.cost_including_tax = item.gst_free
      ? item.unit_cost
      : productApi.calculateCostWithTax(item.unit_cost, item.purchase_tax_rate);
  };

  $scope.updateCost = function (item) {
    item.unit_cost = item.cost = item.gst_free
      ? item.cost_including_tax
      : productApi.calculateCostWithoutTax(item.cost_including_tax, item.purchase_tax_rate);
  };

  $scope.sendOrderToGsf = function () {
    $q.when()
    .then(() => $scope.Order.order.id
      ? $q.when()
      : confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.ORDER_MUST_FIRST_BE_SAVED', {
          name: $translate.instant('COMPANY_SPACE.INTEGRATIONS.GSF.GSF')
        }), null, 'gsfOrderAutoSave'))
    .then(() => $scope.Order.save())
    .then(order => gsfApi.sendOrder(order))
    .then(() => {
      messages.show($translate.instant('COMPANY_SPACE.INTEGRATIONS.GSF.ORDER_CREATED'), 'success');
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => $scope.reload());
  };

  $scope.sendPartstechOrder = function () {
    $q.when()
    .then(() => $scope.Order.order.id
      ? $q.when($scope.Order.order)
      : confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.ORDER_MUST_FIRST_BE_SAVED', {
          name: 'Partstech'
        }), null, 'partsTechOrderAutoSave')
        .then(() => $scope.Order.save()))
    .then(order => partstechApi.send(order))
    .then(() => {
      messages.show($translate.instant('PARTSTECH_SPACE.ORDER_PLACED'), 'success');
    })
    .catch(err => {
      if (err) {
        if (err.url) {
          $window.location.assign(err.url);
        }
        else {
          messages.error(err);
        }
      }
    })
    .finally(() => {
      $state.reload();
    });
  };

  $scope.attachItemsToInvoice = function () {
    if ($scope.grid.selectedItems.length) {
      $scope.Order.attachItemsToInvoice($scope.grid.selectedItems).then(function () {
        $state.reload();
        messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.ITEMS_ADDED_TO_INVOICE'), 'success');
      }, function (err) {
        messages.error(err);
      });
    }
    else {
      messages.error($translate.instant('PRODUCT_SPACE.NO_PRODUCTS_SELECTED'));
    }
  };

  $scope.toggleSelectMode = function () {
    if ($scope.selectMode) {
      $scope.grid.$gridScope.toggleSelectAll(false, false);
      $scope.grid.selectedItems.length = 0;
    }

    $scope.selectMode = !$scope.selectMode;
  };

  $scope.toggleEditMode = function () {
    if ($scope.purchase_order.purchase_order_items_attributes[0].ordering === null) {
      reorderGrid.resetIndexes($scope.purchase_order.purchase_order_items_attributes);
    }

    $scope.grid.$gridScope.enableCellEditOnFocus = !$scope.grid.$gridScope.enableCellEditOnFocus;
    $scope.grid.selectAll(false);

    $scope.editMode = !$scope.editMode;

    if (!$scope.editMode) {
      $scope.$broadcast('endGridReorder');
    }

  };

  $scope.move = function (direction) {
    $scope.Order.form.$setDirty();
    return reorderGrid.moveItem($scope.purchase_order.purchase_order_items_attributes, direction);
  };

  $scope.notAttached = function(row) {
    var id = row.entity.invoice_item_id;

    if (id === null) {
      return true;
    }

    return false;
  };

  $scope.copyPurchaseOrder = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.COPY_ORDER'))
    .then(() => workshopAPI.get('/purchase_order/copy_purchase_order', $scope.purchase_order.id))
    .then(order => {
      sessionObjAPI.setKey('purchase_order_copy', order);

      $state.go('app.purchase-order', {
        vendor_id: order.vendor_id
      }, {
        inherit: false,
        reload : true
      });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.prepOrder = function () {
    $scope.purchase_order.purchase_order_items_attributes = $scope.purchase_order.purchase_order_items_attributes || [];
    $scope.purchase_order.itemsToDelete = [];

    if ($scope.purchase_order.purchase_order_items_attributes.length) {
      $scope.setFlagsAndFunctions();
    }
    else {
      $scope.addItem();
    }
  };

  $scope.setFlagsAndFunctions = function() {
    angular.forEach($scope.purchase_order.purchase_order_items_attributes, function (row, idx) {
      //row.untouched = false;
      row.getTotal = function () {
        var unit_cost = new BigDecimal( row.unit_cost ? row.unit_cost.toString(): '0' ).setScale(4, BigDecimal.ROUND_HALF_UP);
        var quantity_ordered = new BigDecimal( row.quantity_ordered ? row.quantity_ordered.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

        if (!$scope.editable) {
          return row.total;
        }

        return unit_cost
          .multiply(quantity_ordered)
          .setScale(4, BigDecimal.prototype.ROUND_HALF_UP)
          .toString();
      };

      row.getTotalIncludingTax = function () {
        var costIncludingTax = new BigDecimal( row.cost_including_tax ? row.cost_including_tax.toString(): '0' ).setScale(4, BigDecimal.ROUND_HALF_UP);
        var quantityOrdered = new BigDecimal( row.quantity_ordered ? row.quantity_ordered.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

        return costIncludingTax
          .multiply(quantityOrdered)
          .setScale(2, BigDecimal.prototype.ROUND_HALF_UP)
          .toString();
      };

      row.ordering = row.ordering && row.ordering === 0 ? row.ordering: idx * 1000000;
    });
  };

  $scope.addItem = function() {
    $scope.purchase_order.purchase_order_items_attributes.push({
      id                : '',
      purchase_order_id : '',
      product_id        : '',
      item_code         : '',
      gst_free          : false,
      description       : '',
      quantity_ordered  : 0,
      unit_cost         : 0.00,
      cost_including_tax: 0.00,
      total             : 0.00,
      note              : '',
      untouched         : true
    });

    $scope.setFlagsAndFunctions();
  };

  $scope.removeItem = function (row) {
    var deletedItem = $scope.purchase_order.purchase_order_items_attributes.splice(row.rowIndex, 1);

    if ($scope.purchase_order.id && row.entity.id) {
      deletedItem[0]._destroy = '1';
      $scope.purchase_order.itemsToDelete = $scope.purchase_order.itemsToDelete.concat(deletedItem);
    }
  };

  $scope.addNotes = function(row) {
    $uibModal.open({
      templateUrl: AddNoteHtml,
      resolve    : {
        item () {
          return row.entity;
        },
        editable () {
          return $scope.editable;
        }
      },
      controller: [ '$scope', '$uibModalInstance', 'item', 'editable', function ($scope, $uibModalInstance, item, editable) {
        $scope.item     = item;
        $scope.editable = editable;

        $scope.save = function () {
          $uibModalInstance.close(item);
        };

        $scope.close = function () {
          $uibModalInstance.dismiss(false);
        };
      }]
    }).result
    .then(item => {
      row = item;
      $scope.Order.form.$setDirty();
    });
  };

  $scope.productSearch = {
    template  : productSearchApi.getSearchTemplate($scope.ashdown, $scope.repco, $scope.prolink),
    // The field that indicates and item has already been found
    identifier: 'product_id',
    search (typed) {
      return productSearchApi.reservedStockSearch(typed);
    },
    /**
     * Instead of a stream search, there are
     * cases (barcode scan) where we just want
     * a quick find on the code without delaying
     * tab or anything. This is the call for that.
     * @param  {string} typed The entered value to search off of
     * @return {promise}         A promise related to the http call for product
     */
    quickSearch: function (typed) {
      return productSearchApi.quickSearch(typed);
    },
    format: function (product) {
      return angular.isObject(product) ? product.item_code: product;
    },
    populate: function (item, row, isNewProduct) {
      productApi.getPurchaseTaxRate(item)
      .then(taxRate => {
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].cost_including_tax = item.cost_including_tax;
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].description        = item.description;
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].item_code          = item.item_code;
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].product_id         = item.id;
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].product_type       = item.product_type;
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].prolink_sku        = item.prolink_product_sku;
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].repco_sku          = item.repco_product_sku;
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].purchase_tax_rate  = taxRate;
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].unit_cost          = item.cost;
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].quantity_ordered   = 1;

        if ($scope.company.has_dealership && item.id === $scope.dealership.acquisition_product_id) {
          $scope.prepAcquisition(row.rowIndex);
        }
        else if (isNewProduct) {
          $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].quantity       = 1;
          $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].update_product = true;
          $scope.setFlagsAndFunctions();
        }
        else {
          $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].note               = item.comment;
          $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].gst_free           = item.gst_free;
          $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].quantity_ordered   = 1;
          $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].ashdown_ingram_sku = item.ashdown_ingram_product_sku;
          $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].ordering           = row.rowIndex * 1000000;
        }
      });
    },
    choose: function (item, row) {
      var self = this;

      // check to make sure the user isn't searching
      // for a new acquisition on top of an old
      // acquisition.
      if (
        !$scope.company.has_dealership ||
        $scope.dealership.acquisition_product_id !== $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].product_id ||
        $scope.dealership.acquisition_product_id !== item.id
      ) {
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].untouched = false;


        if (item.last) {
          productSearchApi.advancedSearch({
            item_code   : item.item_code,
            product_type: 'S'
          }, row)
          .then(selection => {
            self.populate(selection.selection, row, selection.isNewProduct);
          });
        }
        else {
          self.populate(item, row);
        }
      } else {
        $scope.purchase_order.purchase_order_items_attributes[row.rowIndex].item_code = 'ACQUISITION';
      }
    }
  };

  $scope.emailPurchaseOrder = function() {
    if (!$scope.purchase_order.id) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MUST_SAVE_ORDER_BEFORE_EMAILING'), 'warning');
      return;
    }

    else if ($scope.Order.form.$dirty) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.UNSAVED_CHANGES_NOT_IN_EMAIL'), 'warning');
    }

    messengerApi.email({
      name           : $scope.vendor.company_name,
      email_address  : $scope.vendor.email,
      attachment_type: 3,
      attachment_id  : $scope.purchase_order.id,
      reference      : $scope.purchase_order.order_number,
      vendor_id      : $scope.purchase_order.vendor_id
    })
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success');
    });

  };

  $scope.addAcquisitionItem = function () {
    if ($scope.purchase_order.purchase_order_items_attributes[0].id) {
      $scope.addItem();
    }

    workshopAPI.get('/product', $scope.dealership.acquisition_product_id)
    .then(product => {
      const row = $scope.grid.ngGrid.filteredRows[ $scope.grid.ngGrid.filteredRows.length - 1 ];

      $scope.productSearch.choose(product, row);
    });
  };

  $scope.getTotal = function() {
    var total = BigDecimal.ZERO;

    if (!$scope.editable) {
      return $scope.purchase_order.total;
    }

    angular.forEach($scope.purchase_order.purchase_order_items_attributes, function (row){
      var totalCalc = new BigDecimal( row.getTotal() ? row.getTotal().toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

      total = total.add(totalCalc);
    });

    return total.toString();
  };

  $scope.getTotalIncludingTax = function() {
    var total = BigDecimal.ZERO;

    if (!$scope.editable) {
      return $scope.purchase_order.total_including_tax;
    }

    angular.forEach($scope.purchase_order.purchase_order_items_attributes, function (row) {
      var totalCalc = new BigDecimal( row.getTotalIncludingTax() ? row.getTotalIncludingTax().toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

      total = total.add(totalCalc);
    });

    return total.toString();
  };

  $scope.print = function() {
    if (!$scope.Order.form.$pristine || !$scope.purchase_order.id) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MUST_SAVE_ORDER_BEFORE_PRINTING'), 'warning');
    }
    else {
      $window.open(`${API.url}/reports/jasper_purchase_order/${$scope.purchase_order.id}.pdf`);
    }
  };

  $scope.delete = function() {
    $scope.Order.delete().then(function () {
      $state.go('app.transaction-center.orders');
      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.ORDER'), 'success');
    });
  };

  $scope.process = function () {
    $scope.Order.process()
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.PROCESSED.ORDER'), 'success');
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => $scope.reload());
  };

  $scope.save = function () {
    return $scope.Order.save()
    .then(order => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.ORDER'), 'success');

      return $q.when(order);
    })
    .catch(err => {
      messages.error(err);

      return $q.reject(err);
    })
    .finally(() => $scope.reload());
  };

  $scope.void = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.VOID_ORDER'))
    .then(() => workshopAPI.get('/purchase_orders/void_order', $scope.purchase_order.id))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.VOIDED.ORDER'), 'success');

      $state.go('app.transaction-center.orders');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.getRowColor = function (item, column) {
    const classes = gridAPI.getColumnClasses(column);

    if ($scope.Order.closed() || (($scope.editMode || $scope.selectMode) && item.job_card_number)) {
      classes.push('readonly');
    }
    else if (($scope.editMode || $scope.selectMode) && (item.selected || item.selected)) {//$scope.grid.selectedItems.indexOf(item) >= 0
      classes.push('selected');
    }
    else if (($scope.editMode || $scope.selectMode) && item.job_card_number) {
      classes.push('danger');
    }
    else if (item.product_id && ( ($scope.repco.vendor && !item.repco_sku) || ($scope.ashdown.vendor && !item.ashdown_ingram_sku) || ($scope.prolink.vendor && !item.prolink_sku) )) {
      classes.push('no-sku');
    }

    return classes;
  };

  $scope.changeVendor = function () {
    $scope.Vendor.change().then(function (vendor) {
      return workshopAPI.get('/purchase_orders/change_vendor', [$scope.Order.order.id, vendor.id]);
    }).then(function (order) {
      $state.go('app.purchase-order', {
        vendor_id: order.vendor_id,
        id       : order.id
      });
      messages.show($translate.instant('JS_SPACE.MESSAGES.CHANGED.SUPPLIER'), 'success');
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.isBursonVendor = function () {
    return bursonApi.isVendor($scope.vendor);
  };

  $scope.reload = function () {
    if ($scope.Order.order.id) {

      $state.go('app.purchase-order', {
        acquisition_order_id: null,
        id                  : $scope.Order.order.id,
        vendor_id           : $scope.Order.order.vendor_id
      }, {
        location: 'replace',
        reload  : true
      });
    }
  };

  $scope.sendOrderToAshdown = function () {
    $q.when()
    .then(() => $scope.Order.order.id ? $q.when() : confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.ORDER_MUST_FIRST_BE_SAVED', { name: 'Ashdown Ingram' }), null, 'ashdownOrderAutoSave'))
    .then(() => $scope.Order.save())
    .then(order => $scope.Ashdown.sendOrder(order))
    .then(query => {
      $window.location.assign(`/ashdown.html?${query}`);
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => $scope.reload());
  };

  $scope.sendOrderToBurson = function () {

    $q.when()
    .then(() => $scope.Order.order.id ? $q.when() : confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.ORDER_MUST_FIRST_BE_SAVED', { name: 'Burson EzyParts' }), null, 'bursonOrderAutoSave'))
    .then(() => {
      $scope.block.start();

      return $scope.Order.save();
    })
    .then(order => bursonApi.sendOrder(order))
    .then(() => {
      messages.show($translate.instant('COMPANY_SPACE.INTEGRATIONS.BURSON.ORDER_SENT'), 'success');
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();

      $scope.reload();
    });
  };

  $scope.sendOrderToPartsAuthority = function () {
    $q.when()
    .then(() => $scope.Order.order.id ? $q.when() : confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.ORDER_MUST_FIRST_BE_SAVED', { name: 'Parts Authority' }), null, 'partsAuthorityOrderAutoSave'))
    .then(() => $scope.Order.save())
    .then(order => $scope.PartsAuthorityOrder.send(order))
    .then(() => {
      messages.show('Order submitted to Parts Authority.', 'success');
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => $scope.reload());
  };

  $scope.sendOrderToProLink = function () {
    $q.when()
    .then(() => $scope.Order.order.id ? $q.when() : confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.ORDER_MUST_FIRST_BE_SAVED', { name: 'PROLink' }), null, 'prolinkOrderAutoSave'))
    .then(() => $scope.Order.save())
    .then(order => $scope.PROLink.sendOrder(order))
    .then(query => {
      $window.location.assign(`prolink.html?${query}`);
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => $scope.reload());
  };

  $scope.sendOrderToRepco = function () {
    var counter      = 0;
    var message      = '';
    var origin       = sessionObjAPI.base().origin;
    var queryString  = '';
    var repcoCounter = 1;
    var url          = '';

    var buildQuery = function (url, order) {
      var queryString = {
        hookUrl          : url,
        type             : 'po submit',
        purchase_order_id: order.id,
        order_number     : order.order_number
      };

      angular.forEach(order.purchase_order_items_attributes, item => {
        if (item.repco_sku) {
          queryString[`NEW_ITEM-EXT_PRODUCT_ID[${repcoCounter}]`] = item.repco_sku;
          queryString[`NEW_ITEM-CUST_FIELD13[${repcoCounter}]`]   = item.item_code;
          queryString[`NEW_ITEM-QUANTITY[${repcoCounter}]`]       = parseInt(item.quantity_ordered);
          queryString[`NEW_ITEM-PRICE[${repcoCounter}]`]          = item.unit_cost;
          queryString[`NEW_ITEM-CUST_FIELD12[${repcoCounter}]`]   = repcoCounter;
          repcoCounter++;
        }
        else {
          counter++;
        }
      });

      queryString['NEW_ITEM-CUST_FIELD5[1]']  = order.order_number;
      queryString['NEW_ITEM-CUST_FIELD6[1]']  = 'This is the description';
      queryString['NEW_ITEM-CUST_FIELD5[1]']  = order.order_number;
      queryString['NEW_ITEM-CUST_FIELD11[1]'] = sessionObjAPI.countrySettings().price_includes_tax ? 'Inc': 'Ex';
      queryString['NEW_ITEM-CUST_FIELD11[1]'] = 'Inc';
      queryString['HOOKURL']                  = `${API.url}/purchase_orders/repco/${order.id}`;

      return $.param(queryString);
    };

    $q.when()
    .then(() => $scope.Order.order.id ? $q.when() : confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.ORDER_MUST_FIRST_BE_SAVED', { name: 'Repco' }), null, 'repcoOrderAutoSave'))
    .then(() => $scope.Order.save())
    .then(order => {
      url         = `${origin}workshop.html#/${order.vendor_id}/purchase_order/${order.id}`;
      queryString = buildQuery(url, order);

      if (counter) {
        if (counter === 1) {
          message = $translate.instant('JS_SPACE.INTEGRATIONS.ONE_ITEM_NOT_PRODUCT', { name: 'Repco' });
        }
        else {
          message = $translate.instant('JS_SPACE.INTEGRATIONS.OVER_ONE_ITEM_NOT_PRODUCT', { name: 'Repco', num: counter });
        }

        return confirm.generic(message, 'warning');
      }

      return $q.when(true);
    })
    .then(() => {
      $window.location.assign(`/repco.html?${queryString}`);
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => $scope.reload());
  };

  $scope.isGsfAvailable = function () {
    return $scope.Company.hasIntegration('gsf')
      && gsfApi.isGsfVendor($scope.purchase_order);
  };

  $scope.$on('ngGridEventColumns', function (event) {
    $('#'+ event.currentScope.grid.gridId).resize();
  });

  var copy = $scope.Order.getCopy();

  if (copy) {
    $scope.purchase_order = copy;
  }

  if (purchase_order || copy) {
    $scope.prepOrder();
  }

  // If the url has an acquisition id, launch
  // the acquisition process.
  if ($stateParams.acquisition_id) {
    if ($stateParams.acquisition_id === 'null') {
      messages.error($translate.instant('DEALERSHIP_SPACE.SOMETHING_WENT_WRONG'));
      $state.go('app.purchase-order', {
        vendor_id: vendor.id,
        id       : $scope.purchase_order.id
      });
    } else {
      $scope.launchAcquisition();
    }
  }

  $scope.$watch('purchase_order.purchase_order_items_attributes', function (items) {
    if (!items.length) {
      $scope.addItem();
    }
  }, true);

  $scope.autoCreate = function () {
    $uibModal.open({
      controller : 'autoCreatePurchaseCtrl',
      templateUrl: AutoCreateOrderHtml,
      windowClass: 'lg-modal',
      resolve    : {
        vendor () {
          return $scope.vendor;
        }
      }
    }).result
    .then(products => {
      products = angular.isArray(products) ? products : [ products ];

      angular.forEach(products, (product, i) => {
        if (!i && $scope.purchase_order.purchase_order_items_attributes[0].untouched) {
          $scope.purchase_order.purchase_order_items_attributes[0].cost_including_tax = product.cost_including_tax;
          $scope.purchase_order.purchase_order_items_attributes[0].description        = product.description;
          $scope.purchase_order.purchase_order_items_attributes[0].gst_free           = product.gst_free;
          $scope.purchase_order.purchase_order_items_attributes[0].item_code          = product.item_code;
          $scope.purchase_order.purchase_order_items_attributes[0].note               = product.comment;
          $scope.purchase_order.purchase_order_items_attributes[0].product_id         = product.id;
          $scope.purchase_order.purchase_order_items_attributes[0].quantity_ordered   = product.difference;
          $scope.purchase_order.purchase_order_items_attributes[0].unit_cost          = product.cost;
          $scope.purchase_order.purchase_order_items_attributes[0].untouched          = false;

        }
        else {
          $scope.purchase_order.purchase_order_items_attributes.push({
            cost_including_tax: product.cost_including_tax,
            description       : product.description,
            gst_free          : product.gst_free,
            id                : '',
            item_code         : product.item_code,
            note              : product.comment,
            product_id        : product.id,
            purchase_order_id : '',
            quantity_ordered  : product.difference,
            unit_cost         : product.cost,
            untouched         : false,
            getTotal          : function () {
              var quantity_ordered = new BigDecimal( this.quantity_ordered ? this.quantity_ordered.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);
              var unit_cost        = new BigDecimal( this.unit_cost ? this.unit_cost.toString(): '0' ).setScale(4, BigDecimal.ROUND_HALF_UP);

              if (!$scope.editable) {
                return this.total;
              }

              return unit_cost
              .multiply(quantity_ordered)
              .setScale(4, BigDecimal.prototype.ROUND_HALF_UP)
              .toString();
            },
            getTotalIncludingTax: function () {
              var costIncludingTax = new BigDecimal( this.cost_including_tax ? this.cost_including_tax.toString(): '0' ).setScale(4, BigDecimal.ROUND_HALF_UP);
              var quantityOrdered  = new BigDecimal( this.quantity_ordered ? this.quantity_ordered.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

              return costIncludingTax
                .multiply(quantityOrdered)
                .setScale(2, BigDecimal.prototype.ROUND_HALF_UP)
                .toString();
            }
          });
        }
      });

      return $scope.Order.save();
    })
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.STOCK_ADDED_TO_ORDER'), 'success');
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => $scope.reload());
  };

  // If the url has an acquisition id, launch
  // the acquisition process.
  if ($stateParams.acquisition_order_id) {
    if ($stateParams.acquisition_order_id === 'null') {
      messages.error($translate.instant('DEALERSHIP_SPACE.SOMETHING_WENT_WRONG'));
      $state.go('app.purchase-order', {
        vendor_id: vendor.id,
        id       : $scope.purchase_order.id
      });
    } else {
      $scope.launchAcquisition();
    }
  }
};